import { request } from "./http-client.js"
const userApi = {
  validateResetToken(token) {
    return request.post('api/user/validate-reset-token', {
      token: token
    })
  },
  resetPassword(token, newPassword) {
    return request.post('api/user/reset-password', {
      token,
      newPassword
    })
  },

  forgotPassword(email) {
    return request.post('api/user/forgot-password', {
      email
    })
  }
}
export default userApi